import { Injectable, EventEmitter } from '@angular/core';
import { ShoppingCart, MonitorModel, DDFSQuoteLineModel, DDFSQuoteModel, DDFSCombineModel } from '../models/shopping-cart.model';
import { BehaviorSubject, Observable, of} from 'rxjs';
import { DatePipe } from '@angular/common';
import { CartItem, CartDetailViewModel } from '../models/cart-item.model';
// import 'rxjs/add/observable/throw';
import { HttpClient } from '@angular/common/http';
import { catchError, shareReplay, switchMap, map } from 'rxjs/operators';
import { SKUSearchViewModel } from '../models/search-result.model';
import { ApiResponse, CartResponse, DDFSQuoteResponse, DDFSQuoteTermResponse, CartToQuoteResponse } from '../models/api-response.model';
import { StateModel } from '../models/account-ledger.model';
import { CommonService } from './common.service';
import { AuthService } from './auth.service';
import { isNullOrUndefined } from '../shared/tools.collections';


@Injectable()
export class ShoppingCartService {

    shoppingCarts: ShoppingCart[] = [];
    shoppingCart: ShoppingCart;
    randomCartName: string;
    randomCartNameArray: string[];
    pipe = new DatePipe('en-US');
    now = Date.now();
    myFormattedDate = this.pipe.transform(this.now, 'yyyyMMdd');
    variablePrice: number;
    cartItem: CartItem;
    index: number;
    baseUrl = '/api/shoppingcart';
    changeArray: MonitorModel = {} as MonitorModel;
    cartId: number = 0;
    newCartId: number = 0;
    shoppingcartsNav: ShoppingCart = {} as ShoppingCart;


    private shoppingCartSubject = new BehaviorSubject<any>(this.shoppingcartsNav);
    currentShoppingCarts = this.shoppingCartSubject.asObservable();

    private cartIdSubject = new BehaviorSubject<number>(this.cartId);
    currentCartId = this.cartIdSubject.asObservable();

    private watchChangeSubject = new BehaviorSubject<MonitorModel>(this.changeArray);
    currentChange = this.watchChangeSubject.asObservable();

    private cachedShoppingCarts = new BehaviorSubject<ShoppingCart[]>(null);
    cachedShoppingCarts$ = this.cachedShoppingCarts.asObservable();

    public checkoutNext: EventEmitter<string> = new EventEmitter();

    public shopCartEvent: EventEmitter<string> = new EventEmitter();

    private aliasSubject = new BehaviorSubject<boolean>(false);
    aliasChanged = this.aliasSubject.asObservable();


    private aliasDashboard = new BehaviorSubject<boolean>(false);
    dashboardChanged = this.aliasDashboard.asObservable();

    constructor(
        private http: HttpClient,
        private cs: CommonService,
        private authService: AuthService
    ) { }

    state$ = this.authService.getLoginInfo().pipe(
        switchMap((user) => {
            return this.http.get<StateModel>(this.baseUrl + '/getstate');
        }),
        shareReplay(1)
    );

    monitorAliasLogin(aliasLogin: boolean) {
        this.aliasSubject.next(aliasLogin);
    }

    monitorShoppingCart(shoppingcart: ShoppingCart): void {
        this.shoppingCartSubject.next(shoppingcart);
    }

    setCacheShoppingCart(shoppingcart: ShoppingCart[]): void {
        this.cachedShoppingCarts.next(shoppingcart);
    }

    monitorCartId(cartId: number): void {
        this.cartIdSubject.next(cartId);
    }

    monitorAliasDashboard(aliasLogin: boolean) {
        this.aliasDashboard.next(aliasLogin);
    }

    monitorNumberOfItemsChange(qty: number): void {
        this.changeArray = {
            itemNumberChange: qty,
            stockCodeChange: '',
            statusChange: 0,
            cartNameChange: '',
            cartIdChange: 0
        };
        this.watchChangeSubject.next(this.changeArray);
    }

    monitorStockCodeChange(stockCode: string): void {
        this.changeArray = {
            itemNumberChange: 0,
            stockCodeChange: stockCode,
            statusChange: 0,
            cartNameChange: '',
            cartIdChange: 0
        };
        this.watchChangeSubject.next(this.changeArray);
    }

    monitorStatusChange(status: number): void {
        this.changeArray = {
            itemNumberChange: 0,
            stockCodeChange: '',
            statusChange: status,
            cartNameChange: '',
            cartIdChange: 0
        };
        this.watchChangeSubject.next(this.changeArray);
    }

    monitorCartNameChange(cartName: string): void {
        this.changeArray = {
            itemNumberChange: 0,
            stockCodeChange: '',
            statusChange: 0,
            cartNameChange: cartName,
            cartIdChange: 0
        };
        this.watchChangeSubject.next(this.changeArray);
    }

    monitorCartIdChange(cartId: number): void {
        this.changeArray = {
            itemNumberChange: 0,
            stockCodeChange: '',
            statusChange: 0,
            cartNameChange: '',
            cartIdChange: cartId
        };
        this.watchChangeSubject.next(this.changeArray);
    }

    initialShoppingCart(): number {
        this.randomCartName = this.myFormattedDate.toString() + this.cs.random(100000, 199999).toString();
        this.createShoppingCart(this.randomCartName).subscribe((res: number) => {
            this.newCartId = res;
            this.cs.createCookie('CartId', res[0].cartId.toString(), 7);
        });
        return this.newCartId;
    }

    createShoppingCart(cartName: string): Observable<number> {
        return this.http.get<number>(this.baseUrl + '/createshoppingcart?cartName=' + cartName)
            .pipe(catchError(this.authService.handleError));
    }

    createNewShoppingCart(cartName: string): Observable<ShoppingCart> {
        return this.http.get<ShoppingCart>(this.baseUrl + '/createshoppingcart?cartName=' + cartName)
            .pipe(catchError(this.authService.handleError));
    }

    getShoppingCart(): Observable<ShoppingCart[]> {
        return this.http.get<ShoppingCart[]>(this.baseUrl + '/getcarts')
            .pipe(map((shoppingCarts:ShoppingCart[]) => shoppingCarts.map(val=> {
                    if(isNullOrUndefined(val.isSelected)) {
                        val.isSelected = false;
                    }
                    return val
            })),catchError(this.authService.handleError));
    }

    cachedShoppingCart() {
        if (!this.cachedShoppingCarts$) {
            this.cachedShoppingCarts$ = this.getShoppingCart().pipe(shareReplay(1));
        }

        return this.cachedShoppingCarts$;
    }


    getFinancedCartList(): Observable<ShoppingCart[]> {
        return this.http.get<ShoppingCart[]>(this.baseUrl + '/GetFinancedCartList')
            .pipe(catchError(this.authService.handleError));
    }

    deleteShoppingCart(cartId: number): Observable<boolean> {
        return this.http.get<boolean>(this.baseUrl + '/deletecart?cartId=' + cartId)
            .pipe(catchError(this.authService.handleError));
    }

    DuplicateCart(existingCartId: number): Observable<number> {
        return this.http.get<number>(this.baseUrl + '/DuplicateCart?existingCartId=' + existingCartId)
            .pipe(catchError(this.authService.handleError));
    }

    DuplicateNewCart(existingCartId: number): Observable<ShoppingCart> {
        return this.http.get<ShoppingCart>(this.baseUrl + '/DuplicateCart?existingCartId=' + existingCartId)
            .pipe(catchError(this.authService.handleError));
    }

    addItemToShoppingCart(stockCode: string, cartId: number, inputQty: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/additem?cartId=' + cartId + '&stockCode=' + stockCode + '&inputQty=' + inputQty)
            .pipe(catchError(this.authService.handleError));
    }

    getAllItemsFromShoppingCart(cartId: string, updateStockLevels: boolean, branchCode?: string): Observable<CartDetailViewModel[]> {
        return this.http.get<CartDetailViewModel[]>(this.baseUrl + '/getitemsfromcart?cartId=' + cartId + '&updateStockLevels=' + updateStockLevels + '&branchCode=' + branchCode)
            .pipe(catchError(this.authService.handleError));
    }

    deleteItemFromShoppingCart(cartItemId: number): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/deleteitem?id=' + cartItemId)
            .pipe(catchError(this.authService.handleError));
    }

    UpdateItemQuantity(item: CartDetailViewModel): Observable<CartResponse> {
        return this.http.post<CartResponse>(this.baseUrl + '/UpdateItemQuantity', item)
            .pipe(catchError(this.authService.handleError));
    }

    getCartSearchResult(searchValue: string): Observable<SKUSearchViewModel[]> {
        return this.http.get<SKUSearchViewModel[]>(this.baseUrl + '/getcartsearchresult?searchValue=' + searchValue)
            .pipe(catchError(this.authService.handleError));
    }

    updateCartName(cartName: string, cartId: number): Observable<any> {
        return this.http.get(this.baseUrl + '/updatecartname?cartID=' + cartId + '&newCartName=' + cartName)
            .pipe(catchError(this.authService.handleError));
    }

    updateQuoteName(quoteName: string, cartId: number): Observable<any> {
        return this.http.get(this.baseUrl + '/updateQuoteName?cartID=' + cartId + '&quoteName=' + quoteName)
            .pipe(catchError(this.authService.handleError));
    }


    uploadStockCodesText(cartId: string, stockCodes: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/uploadstockcodestext?cartID=' + cartId + '&stockCodes=' + stockCodes)
            .pipe(catchError(this.authService.handleError));
    }

    importExcelToCart(cartId: string, file: any): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/importexceltocart?cartID=' + cartId, file)
            .pipe(catchError(this.authService.handleError));
    }

    shareCartToggle(cartId: string): Observable<number> {
        return this.http.get<number>(this.baseUrl + '/sharecarttoggle?cartID=' + cartId)
            .pipe(catchError(this.authService.handleError));
    }

    getCartToggle(cartId: string): Observable<number> {
        return this.http.get<number>(this.baseUrl + '/getcarttoggle?cartID=' + cartId)
            .pipe(catchError(this.authService.handleError));
    }

    GetFinanceQuoteByCartId(cartId: number, financeType: string, afterUpdate: boolean): Observable<DDFSQuoteResponse> {
        return this.http.get<DDFSQuoteResponse>(this.baseUrl + '/GetFinanceQuoteByCartId?cartId=' + cartId + '&financeType=' + financeType + '&afterUpdate=' + afterUpdate)
            .pipe(catchError(this.authService.handleError));
    }

    GetFinanceQuoteTermAmount(inputRequest: DDFSQuoteResponse): Observable<DDFSQuoteTermResponse> {
        return this.http.post<DDFSQuoteTermResponse>(this.baseUrl + '/GetFinanceQuoteTermAmount', inputRequest)
            .pipe(catchError(this.authService.handleError));
    }

    SaveFinanceShoppingCartChange(model: DDFSQuoteLineModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/SaveFinanceShoppingCartChange', model)
            .pipe(catchError(this.authService.handleError));
    }

    SavePastThroughCharge(model: DDFSQuoteLineModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/savePastThroughCharge', model)
            .pipe(catchError(this.authService.handleError));
    }

    SaveQuoteDetail(model: DDFSQuoteModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/SaveQuoteDetail', model)
            .pipe(catchError(this.authService.handleError));
    }

    SendQuote(financialType: string, model: DDFSCombineModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/SendQuote?financialType=' + financialType, model)
            .pipe(catchError(this.authService.handleError));
    }

    DeleteFinanceAdditionalChange(model: DDFSQuoteLineModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/DeleteFinanceAdditionalChange', model)
            .pipe(catchError(this.authService.handleError));
    }

    DeleteFinancePassThroughChange(model: DDFSQuoteLineModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/DeleteFinancePassThroughChange', model)
            .pipe(catchError(this.authService.handleError));
    }

    SaveFinanceAdditionalChange(model: DDFSQuoteLineModel): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.baseUrl + '/SaveFinanceAdditionalChange', model)
            .pipe(catchError(this.authService.handleError));
    }

    getState(): Observable<StateModel> {
        return this.state$.pipe(catchError(this.authService.handleError));;
        // return this.http.get(this.baseUrl + '/getstate')
        //     .pipe(catchError(this.authService.handleError));
    }

    getCartName(cartId: string): Observable<string> {
        return this.http.get<string>(this.baseUrl + '/getcartname?cartId=' + cartId)
            .pipe(catchError(this.authService.handleError));
    }

    ModifyFinanceQuote(quoteId: number): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/ModifyFinanceQuote?quoteId=' + quoteId)
            .pipe(catchError(this.authService.handleError));
    }

    GetItemStatusQuantity(cartId: string, cartItemId: number, stockCode: string, qty: number): Observable<CartResponse> {
        return this.http.get<CartResponse>(this.baseUrl + `/GetItemStatusQuantity?cartId=${cartId}&cartItemId=${cartItemId}&stockCode=${stockCode}&qty=${qty}`)
            .pipe(catchError(this.authService.handleError));
    }

    SetActiveCart(cartId: string): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/SetActiveCart?cartId=' + cartId)
            .pipe(catchError(this.authService.handleError));
    }

    createQuoteFromCart(quote: string): Observable<CartToQuoteResponse> {
        const formData: FormData = new FormData();
        formData.append('quote', quote);
        return this.http.post<CartToQuoteResponse>(this.baseUrl + '/ConvertCartToQuote?', formData)
            .pipe(catchError(this.authService.handleError));
    }

    public RandomCartName(shoppingCarts: ShoppingCart[]): string {

        this.randomCartName = this.myFormattedDate.toString() + this.cs.random(100000, 199999).toString();

        while (shoppingCarts.filter(sc => this.randomCartName === sc.cartName).length !== 0) {
            this.randomCartName = this.myFormattedDate.toString() + this.cs.random(100000, 199999).toString();
        }
        return this.randomCartName;
    }

    public setSelected(shoppingCarts: ShoppingCart[], cartId: string) {
        this.removeSelected(shoppingCarts);
        shoppingCarts.forEach(sc => {
            if (sc.cartId.toString() === cartId) {
                sc.isSelected = true;
            }
        });
    }

    public removeSelected(shoppingCarts: ShoppingCart[]) {
        shoppingCarts.forEach(sc => {
            sc.isSelected = false;
        });
    }

    checkoutGoNext = (value: string) => {
        this.checkoutNext.emit(value);
    }

    monitorEvent(shopEvent: string) {
        this.shopCartEvent.emit('clicked');
    }

}
